/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Document } from '../models/Document';
import type { DocumentCreateAnonymizedTextRequest } from '../models/DocumentCreateAnonymizedTextRequest';
import type { DocumentUploadRequest } from '../models/DocumentUploadRequest';
import type { ExternalPatientSessionCreate } from '../models/ExternalPatientSessionCreate';
import type { FormFillJob } from '../models/FormFillJob';
import type { PaginatedPatientSessionSummaryList } from '../models/PaginatedPatientSessionSummaryList';
import type { PatientSessionCreateRequest } from '../models/PatientSessionCreateRequest';
import type { PatientSessionDetails } from '../models/PatientSessionDetails';
import type { PatientSessionPartialUpdateRequest } from '../models/PatientSessionPartialUpdateRequest';
import type { PatientSessionSummary } from '../models/PatientSessionSummary';
import type { PatientSessionUpdateRequest } from '../models/PatientSessionUpdateRequest';
import type { Photo } from '../models/Photo';
import type { PhotoUploadRequest } from '../models/PhotoUploadRequest';
import type { Recording } from '../models/Recording';
import type { RecordingUploadRequest } from '../models/RecordingUploadRequest';
import type { SessionBillingCodes } from '../models/SessionBillingCodes';
import type { SessionBillingCodesCreate } from '../models/SessionBillingCodesCreate';
import type { SessionBillingCodesUpdate } from '../models/SessionBillingCodesUpdate';
import type { SummarizationReport } from '../models/SummarizationReport';
import type { SummarizationReportCreateRequest } from '../models/SummarizationReportCreateRequest';
import type { SummarizationReportMessage } from '../models/SummarizationReportMessage';
import type { SummarizationReportMessageCreate } from '../models/SummarizationReportMessageCreate';
import type { SummarizationReportMessageUpdate } from '../models/SummarizationReportMessageUpdate';
import type { SummaryDownloadLink } from '../models/SummaryDownloadLink';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class PatientSessionsService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Lists the sessions of the current user, newest first. The response is paginated only when `page_size` is given; without it the complete list is returned as a plain array.
     * @returns PaginatedPatientSessionSummaryList
     * @throws ApiError
     */
    public patientSessionList({
        cursor,
        pageSize,
        search,
        status,
        type,
    }: {
        /**
         * The pagination cursor value.
         */
        cursor?: string,
        /**
         * Number of results to return per page.
         */
        pageSize?: number,
        /**
         * A search term.
         */
        search?: string,
        /**
         * Multiple values may be separated by commas.
         */
        status?: Array<string>,
        /**
         * Uses different filters for desktop and mobile sessions. For mobile sessions it only returns new sessions created on mobile. For desktop sessions it returns all sessions except new mobile sessions.
         */
        type?: 'desktop' | 'mobile',
    }): CancelablePromise<PaginatedPatientSessionSummaryList> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/patient-sessions/',
            query: {
                'cursor': cursor,
                'page_size': pageSize,
                'search': search,
                'status': status,
                'type': type,
            },
        });
    }
    /**
     * @returns PatientSessionDetails
     * @throws ApiError
     */
    public patientSessionCreate({
        requestBody,
    }: {
        requestBody?: PatientSessionCreateRequest,
    }): CancelablePromise<PatientSessionDetails> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/patient-sessions/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns PatientSessionDetails
     * @throws ApiError
     */
    public patientSessionsRetrieve({
        sessionId,
    }: {
        /**
         * A unique integer value identifying this patient session.
         */
        sessionId: number,
    }): CancelablePromise<PatientSessionDetails> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/patient-sessions/{session_id}/',
            path: {
                'session_id': sessionId,
            },
        });
    }
    /**
     * @returns PatientSessionDetails
     * @throws ApiError
     */
    public patientSessionUpdate({
        sessionId,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this patient session.
         */
        sessionId: number,
        requestBody?: PatientSessionUpdateRequest,
    }): CancelablePromise<PatientSessionDetails> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/patient-sessions/{session_id}/',
            path: {
                'session_id': sessionId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns PatientSessionDetails
     * @throws ApiError
     */
    public patientSessionPartialUpdate({
        sessionId,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this patient session.
         */
        sessionId: number,
        requestBody?: PatientSessionPartialUpdateRequest,
    }): CancelablePromise<PatientSessionDetails> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/api/patient-sessions/{session_id}/',
            path: {
                'session_id': sessionId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns void
     * @throws ApiError
     */
    public patientSessionDelete({
        sessionId,
    }: {
        /**
         * A unique integer value identifying this patient session.
         */
        sessionId: number,
    }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/patient-sessions/{session_id}/',
            path: {
                'session_id': sessionId,
            },
        });
    }
    /**
     * @returns SessionBillingCodes
     * @throws ApiError
     */
    public patientSessionBillingCodesRetrieve({
        sessionId,
    }: {
        sessionId: number,
    }): CancelablePromise<SessionBillingCodes> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/patient-sessions/{session_id}/billing-codes/',
            path: {
                'session_id': sessionId,
            },
        });
    }
    /**
     * @returns SessionBillingCodes
     * @throws ApiError
     */
    public patientSessionBillingCodesCreate({
        sessionId,
        requestBody,
    }: {
        sessionId: number,
        requestBody: SessionBillingCodesCreate,
    }): CancelablePromise<SessionBillingCodes> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/patient-sessions/{session_id}/billing-codes/',
            path: {
                'session_id': sessionId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns SessionBillingCodes
     * @throws ApiError
     */
    public patientSessionsBillingCodesRetrieve({
        id,
        sessionId,
    }: {
        /**
         * A unique integer value identifying this billing codes.
         */
        id: number,
        sessionId: number,
    }): CancelablePromise<SessionBillingCodes> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/patient-sessions/{session_id}/billing-codes/{id}/',
            path: {
                'id': id,
                'session_id': sessionId,
            },
        });
    }
    /**
     * @returns SessionBillingCodesUpdate
     * @throws ApiError
     */
    public patientSessionBillingCodesUpdate({
        id,
        sessionId,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this billing codes.
         */
        id: number,
        sessionId: number,
        requestBody: SessionBillingCodesUpdate,
    }): CancelablePromise<SessionBillingCodesUpdate> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/patient-sessions/{session_id}/billing-codes/{id}/',
            path: {
                'id': id,
                'session_id': sessionId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns SessionBillingCodesUpdate
     * @throws ApiError
     */
    public patientSessionBillingCodesPartialUpdate({
        id,
        sessionId,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this billing codes.
         */
        id: number,
        sessionId: number,
        requestBody: SessionBillingCodesUpdate,
    }): CancelablePromise<SessionBillingCodesUpdate> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/api/patient-sessions/{session_id}/billing-codes/{id}/',
            path: {
                'id': id,
                'session_id': sessionId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns void
     * @throws ApiError
     */
    public patientSessionBillingCodesDestroy({
        id,
        sessionId,
    }: {
        /**
         * A unique integer value identifying this billing codes.
         */
        id: number,
        sessionId: number,
    }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/patient-sessions/{session_id}/billing-codes/{id}/',
            path: {
                'id': id,
                'session_id': sessionId,
            },
        });
    }
    /**
     * @returns Document
     * @throws ApiError
     */
    public documentCreate({
        sessionId,
        requestBody,
    }: {
        sessionId: number,
        requestBody: DocumentUploadRequest,
    }): CancelablePromise<Document> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/patient-sessions/{session_id}/documents/',
            path: {
                'session_id': sessionId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns void
     * @throws ApiError
     */
    public documentDelete({
        documentId,
        sessionId,
    }: {
        /**
         * A unique integer value identifying this document.
         */
        documentId: number,
        sessionId: number,
    }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/patient-sessions/{session_id}/documents/{document_id}/',
            path: {
                'document_id': documentId,
                'session_id': sessionId,
            },
        });
    }
    /**
     * @returns Document
     * @throws ApiError
     */
    public documentCreateAnonymizedText({
        sessionId,
        requestBody,
    }: {
        sessionId: number,
        requestBody: DocumentCreateAnonymizedTextRequest,
    }): CancelablePromise<Document> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/patient-sessions/{session_id}/documents/anonymized-text/',
            path: {
                'session_id': sessionId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns Photo
     * @throws ApiError
     */
    public photoCreate({
        sessionId,
        requestBody,
    }: {
        sessionId: number,
        requestBody: PhotoUploadRequest,
    }): CancelablePromise<Photo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/patient-sessions/{session_id}/photos/',
            path: {
                'session_id': sessionId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns void
     * @throws ApiError
     */
    public photoDelete({
        photoId,
        sessionId,
    }: {
        /**
         * A unique integer value identifying this photo.
         */
        photoId: number,
        sessionId: number,
    }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/patient-sessions/{session_id}/photos/{photo_id}/',
            path: {
                'photo_id': photoId,
                'session_id': sessionId,
            },
        });
    }
    /**
     * @returns Recording
     * @throws ApiError
     */
    public recordingCreate({
        sessionId,
        requestBody,
    }: {
        sessionId: number,
        requestBody: Array<RecordingUploadRequest>,
    }): CancelablePromise<Array<Recording>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/patient-sessions/{session_id}/recordings/',
            path: {
                'session_id': sessionId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns void
     * @throws ApiError
     */
    public recordingDelete({
        recordingId,
        sessionId,
    }: {
        /**
         * A unique integer value identifying this recording.
         */
        recordingId: number,
        sessionId: number,
    }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/patient-sessions/{session_id}/recordings/{recording_id}/',
            path: {
                'recording_id': recordingId,
                'session_id': sessionId,
            },
        });
    }
    /**
     * @returns SummarizationReport
     * @throws ApiError
     */
    public summarizationReportCreate({
        sessionId,
        requestBody,
    }: {
        sessionId: number,
        requestBody?: SummarizationReportCreateRequest,
    }): CancelablePromise<SummarizationReport> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/patient-sessions/{session_id}/reports/',
            path: {
                'session_id': sessionId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns void
     * @throws ApiError
     */
    public summarizationReportDelete({
        reportId,
        sessionId,
    }: {
        /**
         * A unique integer value identifying this summarization report.
         */
        reportId: number,
        sessionId: number,
    }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/patient-sessions/{session_id}/reports/{report_id}/',
            path: {
                'report_id': reportId,
                'session_id': sessionId,
            },
        });
    }
    /**
     * @returns FormFillJob
     * @throws ApiError
     */
    public patientSessionsReportsFormFillJobsRetrieve({
        id,
        reportId,
        sessionId,
    }: {
        /**
         * A unique integer value identifying this form fill job.
         */
        id: number,
        reportId: number,
        sessionId: string,
    }): CancelablePromise<FormFillJob> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/patient-sessions/{session_id}/reports/{report_id}/form-fill-jobs/{id}/',
            path: {
                'id': id,
                'report_id': reportId,
                'session_id': sessionId,
            },
        });
    }
    /**
     * @returns FormFillJob
     * @throws ApiError
     */
    public patientSessionsReportsFormFillJobsDownloadCreate({
        id,
        reportId,
        sessionId,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this form fill job.
         */
        id: number,
        reportId: number,
        sessionId: string,
        requestBody?: FormFillJob,
    }): CancelablePromise<FormFillJob> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/patient-sessions/{session_id}/reports/{report_id}/form-fill-jobs/{id}/download/',
            path: {
                'id': id,
                'report_id': reportId,
                'session_id': sessionId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns FormFillJob
     * @throws ApiError
     */
    public patientSessionsReportsFormFillJobsDownloadFileRetrieve({
        id,
        reportId,
        sessionId,
    }: {
        /**
         * A unique integer value identifying this form fill job.
         */
        id: number,
        reportId: number,
        sessionId: string,
    }): CancelablePromise<FormFillJob> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/patient-sessions/{session_id}/reports/{report_id}/form-fill-jobs/{id}/download/file/',
            path: {
                'id': id,
                'report_id': reportId,
                'session_id': sessionId,
            },
        });
    }
    /**
     * @returns SummarizationReportMessage
     * @throws ApiError
     */
    public summarizationReportMessagePost({
        reportId,
        sessionId,
        requestBody,
    }: {
        reportId: number,
        sessionId: number,
        requestBody: SummarizationReportMessageCreate,
    }): CancelablePromise<Array<SummarizationReportMessage>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/patient-sessions/{session_id}/reports/{report_id}/messages/',
            path: {
                'report_id': reportId,
                'session_id': sessionId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns SummarizationReportMessage
     * @throws ApiError
     */
    public summarizationReportMessageUpdate({
        messageId,
        reportId,
        sessionId,
        requestBody,
    }: {
        messageId: number,
        reportId: number,
        sessionId: number,
        requestBody: SummarizationReportMessageUpdate,
    }): CancelablePromise<SummarizationReportMessage> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/patient-sessions/{session_id}/reports/{report_id}/messages/{message_id}/',
            path: {
                'message_id': messageId,
                'report_id': reportId,
                'session_id': sessionId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns SummarizationReportMessage
     * @throws ApiError
     */
    public summarizationReportMessagePartialUpdate({
        messageId,
        reportId,
        sessionId,
        requestBody,
    }: {
        messageId: number,
        reportId: number,
        sessionId: number,
        requestBody: SummarizationReportMessageUpdate,
    }): CancelablePromise<SummarizationReportMessage> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/api/patient-sessions/{session_id}/reports/{report_id}/messages/{message_id}/',
            path: {
                'message_id': messageId,
                'report_id': reportId,
                'session_id': sessionId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Returns the generated DOCX file.
     * @returns binary
     * @throws ApiError
     */
    public patientSessionDownloadSummaryDocx({
        messageId,
        reportId,
        sessionId,
        token,
    }: {
        messageId: number,
        reportId: number,
        sessionId: number,
        token?: string,
    }): CancelablePromise<Blob> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/patient-sessions/{session_id}/reports/{report_id}/messages/{message_id}/docx/',
            path: {
                'message_id': messageId,
                'report_id': reportId,
                'session_id': sessionId,
            },
            query: {
                'token': token,
            },
        });
    }
    /**
     * Creates a temporary link for downloading a DOCX file.
     * @returns SummaryDownloadLink
     * @throws ApiError
     */
    public patientSessionGenerateSummaryDocxLink({
        messageId,
        reportId,
        sessionId,
    }: {
        messageId: number,
        reportId: number,
        sessionId: number,
    }): CancelablePromise<SummaryDownloadLink> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/patient-sessions/{session_id}/reports/{report_id}/messages/{message_id}/docx/',
            path: {
                'message_id': messageId,
                'report_id': reportId,
                'session_id': sessionId,
            },
        });
    }
    /**
     * @returns binary
     * @throws ApiError
     */
    public patientSessionDownloadSummaryPdf({
        messageId,
        reportId,
        sessionId,
    }: {
        messageId: number,
        reportId: number,
        sessionId: number,
    }): CancelablePromise<Blob> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/patient-sessions/{session_id}/reports/{report_id}/messages/{message_id}/pdf/',
            path: {
                'message_id': messageId,
                'report_id': reportId,
                'session_id': sessionId,
            },
        });
    }
    /**
     * @returns SummaryDownloadLink
     * @throws ApiError
     */
    public patientSessionGenerateSummaryPdfLink({
        messageId,
        reportId,
        sessionId,
    }: {
        messageId: number,
        reportId: number,
        sessionId: number,
    }): CancelablePromise<SummaryDownloadLink> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/patient-sessions/{session_id}/reports/{report_id}/messages/{message_id}/pdf/',
            path: {
                'message_id': messageId,
                'report_id': reportId,
                'session_id': sessionId,
            },
        });
    }
    /**
     * Send patient session's report summary message to external provider
     * @returns any
     * @throws ApiError
     */
    public externalPatientSessionReportSend({
        messageId,
        reportId,
        sessionId,
    }: {
        messageId: number,
        reportId: number,
        sessionId: number,
    }): CancelablePromise<{
        message?: string;
        /**
         * Response from the external API provider
         */
        response?: Record<string, any>;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/patient-sessions/{session_id}/reports/{report_id}/messages/{message_id}/send-ext/',
            path: {
                'message_id': messageId,
                'report_id': reportId,
                'session_id': sessionId,
            },
        });
    }
    /**
     * Create a new patient session for external providers with company validation
     * @returns PatientSessionSummary
     * @throws ApiError
     */
    public externalPatientSessionCreate({
        companySlug,
        requestBody,
    }: {
        /**
         * The slug identifying the external company/provider. Determines the expected structure of the `data` field.
         */
        companySlug: string,
        requestBody: ExternalPatientSessionCreate,
    }): CancelablePromise<PatientSessionSummary> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/patient-sessions/ext/{company_slug}/',
            path: {
                'company_slug': companySlug,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
